import { useEffect } from "react"
import { loadScript } from "../utils/loadScripts"
import Footer from "./Footer"

function Header() {

    useEffect(() => {
        const init = async () => {
            await loadScript("/assets/js/plugins/jquery.min.js")
           // await loadScript("/assets/js/plugins/swup.min.js")
            await loadScript("/assets/js/plugins/swiper.min.js")
            await loadScript("/assets/js/plugins/fancybox.min.js")
            await loadScript("/assets/js/plugins/gsap.min.js")
            await loadScript("/assets/js/plugins/smooth-scroll.js")
            await loadScript("/assets/js/plugins/ScrollTrigger.min.js")
            await loadScript("/assets/js/plugins/ScrollTo.min.js")

            await loadScript("assets/js/main.js")
        }

        init()

    }, [])
    return (
        <>

            <div className="mil-wrapper" id="top">
                <div className="mil-ball">
                    <span className="mil-icon-1">
                        <svg viewBox="0 0 128 128">
                            <path d="M106.1,41.9c-1.2-1.2-3.1-1.2-4.2,0c-1.2,1.2-1.2,3.1,0,4.2L116.8,61H11.2l14.9-14.9c1.2-1.2,1.2-3.1,0-4.2	c-1.2-1.2-3.1-1.2-4.2,0l-20,20c-1.2,1.2-1.2,3.1,0,4.2l20,20c0.6,0.6,1.4,0.9,2.1,0.9s1.5-0.3,2.1-0.9c1.2-1.2,1.2-3.1,0-4.2	L11.2,67h105.5l-14.9,14.9c-1.2,1.2-1.2,3.1,0,4.2c0.6,0.6,1.4,0.9,2.1,0.9s1.5-0.3,2.1-0.9l20-20c1.2-1.2,1.2-3.1,0-4.2L106.1,41.9	z" />
                        </svg>
                    </span>
                    <div className="mil-more-text">More</div>
                    <div className="mil-choose-text">Сhoose</div>
                </div>


                {/* preloader */}
             { /* <div className="mil-preloader">
                    <div className="mil-preloader-animation">
                        <div className="mil-pos-abs mil-animation-1">
                            <p className="mil-h3 mil-muted mil-thin">Smart.</p>
                            <p className="mil-h3 mil-muted">Simple.</p>
                            <p className="mil-h3 mil-muted mil-thin">Striking</p>
                        </div>
                        <div className="mil-pos-abs mil-animation-2">
                            <div className="mil-reveal-frame">
                                <p className="mil-reveal-box"></p>
                                <p className="mil-h3 mil-muted mil-thin">black&white.agency</p>
                            </div>
                        </div>
                    </div>
                </div>*/}
                {/*   preloader end */}

                {/*   scrollbar progress */}
                <div className="mil-progress-track">
                    <div className="mil-progress"></div>
                </div>
                {/*   scrollbar progress end */}

                {/* //  //  menu */}
                <div className="mil-menu-frame">
                    {/*   frame clone  */}
                    <div className="mil-frame-top">
                        <a href="/" className="mil-logo">b&w</a>
                        <div className="mil-menu-btn">
                            <span></span>
                        </div>
                    </div>
                    {/* //  frame clone end  */}
                    <div className="container">
                        <div className="mil-menu-content">
                            <div className="row">
                                <div className="col-xl-5">

                                    <nav className="mil-main-menu" id="swupMenu">
                                        <ul>
                                            <li className="mil-has-children mil-active">
                                                <a href="/">Home</a>
                                            </li>
                                            <li className="mil-has-children">
                                                <a href="/services">Services</a>
                                            </li>
                                            <li className="mil-has-children">
                                                <a href="/portfolio">Portfolio</a>
                                            </li>
                                            <li className="mil-has-children">
                                                <a href="#.">Events</a>
                                            </li>
                                            <li className="mil-has-children">
                                                <a href="/blog">Blog</a>
                                            </li>
                                            <li className="mil-has-children">
                                                <a href="/careers">Careers</a>
                                            </li>
                                            <li className="mil-has-children">
                                                <a href="/contact">Contact</a>
                                            </li>
                                        </ul>
                                    </nav>

                                </div>
                                <div className="col-xl-7">

                                    <div className="mil-menu-right-frame">
                                        <div className="mil-animation-in">
                                            <div className="mil-animation-frame">
                                                <div className="mil-animation mil-position-1 mil-scale" data-value-1="2" data-value-2="2"></div>
                                            </div>
                                        </div>
                                        <div className="mil-menu-right">
                                            <div className="row">
                                                <div className="col-lg-8 mil-mb-60">

                                                    <h6 className="mil-muted mil-mb-30">Projects</h6>

                                                    <ul className="mil-menu-list">
                                                        <li><a href="#" className="mil-light-soft">Ardh Group (Distribution & Supplychain)</a></li>
                                                        <li><a href="#" className="mil-light-soft">Fablab (Lab Grown Diamonds)</a></li>
                                                        <li><a href="#" className="mil-light-soft">Inevert (IT Solutions)</a></li>
                                                        <li><a href="#" className="mil-light-soft">Bhoomi Kitchens (Food & Beverage)</a></li>
                                                        <li><a href="#" className="mil-light-soft">Bhonam (Food & Beverage)</a></li>
                                                        <li><a href="#" className="mil-light-soft">Tony's Chocolonely</a></li>
                                                    </ul>

                                                </div>
                                                <div className="col-lg-4 mil-mb-60">

                                                    <h6 className="mil-muted mil-mb-30">Useful links</h6>

                                                    <ul className="mil-menu-list">
                                                        <li><a href="/privacypolicy" className="mil-light-soft">Privacy Policy</a></li>
                                                        <li><a href="/termsandcondition" className="mil-light-soft">Terms and conditions</a></li>
                                                        <li><a href="/cookiesandolicies" className="mil-light-soft">Cookie Policy</a></li>
                                                    </ul>

                                                </div>
                                            </div>
                                            <div className="mil-divider mil-mb-60"></div>
                                            <div className="row justify-content-between">
                                                <h6 className="mil-muted mil-mb-30">Our other ventures</h6>
                                                <div className="col-lg-2 mil-mb-60">
                                                    <a href="https://learnsphere.cc/" target="_blank"><img src="/assets/img/brand-kit/learnsphere-white-logo.svg" width="130px" alt="Learnsphere" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* //  menu  */}

                {/* //  curtain  */}
                <div className="mil-curtain"></div>
                {/* //  curtain end  */}

                {/*  frame  */}
                <div className="mil-frame">
                    <div className="mil-frame-top">
                        <a href="/" className="mil-logo">b&w.</a>
                        <div className="mil-menu-btn">
                            <span></span>
                        </div>
                    </div>
                    <div className="mil-frame-bottom">
                        <div className="mil-current-page"></div>
                        <div className="mil-back-to-top">
                            <a href="#top" className="mil-link mil-dark mil-arrow-place">
                                <span>Back to top</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Header